module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0022.jpg?v=b7923bcd";